<script setup lang="ts">
import { type Ref, ref, toRef } from 'vue';
import { FontAwesomeIcon } from '@shared/plugin/icons';
import VPopover, { type VPopoverProps } from '../VPopover/VPopover.vue';

const props = withDefaults(
  defineProps<{
    active?: boolean;
    label?: string;
    sticky?: boolean;
    theme?: VPopoverProps['theme'];
  }>(),
  {
    active: true,
    sticky: false,
    theme: 'dark',
  },
);

const popoverRef = ref<InstanceType<typeof VPopover>>();

defineExpose<{
  visible: Ref<boolean>;
}>({
  visible: toRef(() => popoverRef.value?.visible),
});
</script>

<template>
  <div>
    <div @mouseenter="popoverRef?.show" @mouseleave="() => !props.sticky && popoverRef?.hide()">
      <slot></slot>
    </div>
    <VPopover
      v-if="props.active"
      v-bind="$attrs"
      class="max-w-[300px]"
      ref="popoverRef"
      role="tooltip"
      :theme="props.theme"
    >
      <div class="flex gap-2 px-3 py-2 text-sm">
        <FontAwesomeIcon class="mt-0.5 text-base" icon="far fa-info-circle" />
        <div
          class="whitespace-pre-wrap"
          v-if="!$slots.content"
          v-sanitized-html="props.label"
        ></div>
        <div>
          <slot name="content"></slot>
        </div>
      </div>
    </VPopover>
  </div>
</template>
